import React from 'react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { PermissionDto } from 'api/Identity/Types/PermissionDto'
import { PermissionsEnum } from 'api/Identity/Types/PermissionsEnum'
import { ChevronDown } from 'lucide-react'
import { hasPermission } from 'utils/permissionsValidator'

interface TransactionMenuProps {
  handleAuditLog: () => void
  handleCustomize?: () => void
  handleProviderValidation?: () => void
  permissions: PermissionDto[]
  buttonContent?: string
  isSkrillPaymentProviderType?: boolean
  isBankPaymentProviderType?: boolean
  isWalletWithdrawalType?: boolean
  isAdminCustomizationAvailable?: boolean
  sendBankStatementNeededCCCoveredIBEmailRequest?: () => void
  sendBankStatementNeededDepositConfirmationEmailRequest?: () => void
}

export const TransactionMenu: React.FC<TransactionMenuProps> = (props) => {
  const {
    handleAuditLog,
    handleCustomize,
    permissions,
    handleProviderValidation,
    isSkrillPaymentProviderType,
    isBankPaymentProviderType,
    isWalletWithdrawalType,
    sendBankStatementNeededCCCoveredIBEmailRequest,
    sendBankStatementNeededDepositConfirmationEmailRequest,
    isAdminCustomizationAvailable = false,
  } = props

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={<Button type='button' variant='outline' size='icon' aria-label='More options' />}
      >
        <ChevronDown />
      </DropdownMenuTrigger>

      <DropdownMenuContent>
        <DropdownMenuItem disabled={false} onClick={handleAuditLog} data-test='audit-log-button'>
          Audit Log
        </DropdownMenuItem>
        {isAdminCustomizationAvailable && (
          <DropdownMenuItem
            disabled={!hasPermission(permissions, PermissionsEnum.CanManageWalletsService)}
            onClick={handleCustomize}
            data-test='admin-button'
          >
            Admin
          </DropdownMenuItem>
        )}
        {handleProviderValidation && isSkrillPaymentProviderType && (
          <DropdownMenuItem
            onClick={handleProviderValidation}
            data-test='provider-validation-button'
          >
            Provider Validation
          </DropdownMenuItem>
        )}

        {isWalletWithdrawalType && isBankPaymentProviderType && (
          <DropdownMenuSub>
            <DropdownMenuSubTrigger
              disabled={!hasPermission(permissions, PermissionsEnum.CanRequestWithdrawalEmails)}
              data-test='requests-button'
            >
              Requests
            </DropdownMenuSubTrigger>
            <DropdownMenuSubContent>
              <DropdownMenuItem
                key='bank-statement-needed-cc-covered-ib'
                onClick={() =>
                  sendBankStatementNeededCCCoveredIBEmailRequest &&
                  sendBankStatementNeededCCCoveredIBEmailRequest()
                }
              >
                Request Bank statement
              </DropdownMenuItem>

              <DropdownMenuItem
                key='bank-statement-needed-deposit-confirmation'
                onClick={() =>
                  sendBankStatementNeededDepositConfirmationEmailRequest &&
                  sendBankStatementNeededDepositConfirmationEmailRequest()
                }
              >
                Request Proof of Deposit
              </DropdownMenuItem>
            </DropdownMenuSubContent>
          </DropdownMenuSub>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
